export enum LsValueType {
  token = "token",
  exp = "exp",
  locale = "locale",
  realTimeConfig = "realTimeConfig",
  languagesList = "languagesList",
  currentPage = "currentPage",
}
